import AnalyticsCard from '../AnalyticsCard/AnalyticsCard';
import './AnalyticsHeader.css';
import ProgressCircle from '../../../../../components/UI/ProgressCircle/ProgressCircle';
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import getNameFromEmail from '/src/utils/getNameFromEmail';
import ScoreBarLinear from '../../../../../components/UI/ScoreBarLinear/ScoreBarLinear';

const CONVERSATIONS_LIST_PATH = '/supervision/conversations/list';

function AnalyticsHeader({ overallScore = 0, categories = [], isLoading = false }) {
    const buildConversationsUrl = (agent, category) => {
        const params = new URLSearchParams();
        if (agent) params.append("agent_id", agent);
        if (category) params.append("criteria_categories", category);
        return `${CONVERSATIONS_LIST_PATH}?${params.toString()}`;
    };

    return (
        <div className="analytics-header">
            { /** Carte principale affichant le score general */}
            < AnalyticsCard title="Overall Score" >
                <Tippy
                    className="progress-circle-tooltip"
                    content={
                        <div className="progress-circle-warning-tooltip">
                            Average percentage of passed criteria across all evaluated calls.
                        </div>
                    }
                    placement="bottom"
                    delay={[200, 0]}
                >
                    <div>
                        <ProgressCircle value={isLoading ? 0 : overallScore} />
                    </div>
                </Tippy>
            </AnalyticsCard >
            {categories.map(cat => (
                <AnalyticsCard key={cat.name} title={cat.name}>

                    <div className="analytics-card-details">
                        <div className="main-row-analytics-header">
                            <span style={{ fontSize: '26px', fontWeight: 'bold' }}>{cat.score}%</span>
                            <div className="score-bar-main-container">
                                <ScoreBarLinear score={cat.score} color={cat.bestCriterion?.color || "var(--main)"} />
                            </div>
                        </div>

                        <div className="row-analytics-header">
                            Avg. Score
                        </div>
                        <div className="divider div-transparent div-dot"></div>
                        <div className="title-row-analytics-header">
                            <strong>Performers</strong>
                        </div>
                        <div className="row-analytics-header">
                            Best <div style={{ fontWeight: "bold", display: "flex", gap: "5px" }}>
                                {cat.bestAgent ? (
                                    <a
                                        href={buildConversationsUrl(cat.bestAgent.name, cat.name)}
                                        className="analytics-header-agent-link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <div className='firstname-analytics-header'>
                                            {getNameFromEmail(cat.bestAgent.name).firstName}
                                        </div>
                                        <div className='lastname-analytics-header'>
                                            {getNameFromEmail(cat.bestAgent.name).lastName}
                                        </div>
                                        <div>{cat.bestAgent.score}%</div>
                                    </a>
                                ) : <div>N/A</div>}
                            </div>
                        </div>
                        <div className="row-analytics-header">
                            Lowest<div style={{ fontWeight: "bold", display: "flex", gap: "5px" }}>
                                {cat.worstAgent ? (
                                    <a
                                        href={buildConversationsUrl(cat.worstAgent.name, cat.name)}
                                        className="analytics-header-agent-link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <div className='firstname-analytics-header'>
                                            {getNameFromEmail(cat.worstAgent.name).firstName}
                                        </div>{" "}
                                        <div className='lastname-analytics-header'>
                                            {getNameFromEmail(cat.worstAgent.name).lastName}
                                        </div>
                                        <div>{cat.worstAgent.score}% </div>
                                    </a>
                                ) : <div>N/A</div>}
                            </div>
                        </div>
                        <div className="divider div-transparent div-dot"></div>
                        <div className="title-row-analytics-header" >
                            <strong>Criteria</strong>
                        </div>
                        <div className="row-analytics-header">
                            Best <strong> {cat.bestCriterion?.name || "N/A"}</strong>
                        </div>
                        <div className="row-analytics-header">
                            Lowest <strong>{cat.worstCriterion?.name || "N/A"}</strong>
                        </div>
                    </div>
                </AnalyticsCard>
            ))
            }
        </div >

    );
}

export default AnalyticsHeader;
